import { PopoverType } from '../../../Popovers/redux/types';
export function getFeedNotificationQueue(_a) {
    var deviationId = _a.deviationId, typeId = _a.typeId;
    return "feed-" + typeId + "-" + deviationId;
}
export function getFeedAddToCollectionPopoverId(_a) {
    var deviationId = _a.deviationId, typeId = _a.typeId;
    return PopoverType.ADD_TO_COLLECTION_PRIMARY + "-" + typeId + "-" + deviationId;
}
//# sourceMappingURL=helpers.js.map